import * as yup from "yup";
import {
  fieldMustBePositive,
  fieldMustBeZeroOrHigher,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";
import { CurrencyType } from "../../../../../common/enums";

export const refillCardFormSchema = yup
  .object({
    editUserPlanId: yup.number().nullable().defined(),
    studioId: yup.number().required().defined(),
    userId: yup.number().min(0).nullable().defined(),
    familyId: yup.number().min(0).nullable().defined(),
    planId: yup.number().min(0).required(requiredField("План")).defined(),
    paymentTypeId: yup.number().required().defined(),
    startDate: yup.date().nullable().defined(),
    endDate: yup.date().nullable().defined(),
    numberOfVisits: yup
      .number()
      .required(requiredField("Брой посещения"))
      .min(0, fieldMustBeZeroOrHigher("Брой посещения"))
      .defined(),
    price: yup
      .number()
      .nullable()
      .required(requiredField("Цена"))
      .positive(fieldMustBePositive("Цена"))
      .defined(),
    currencyId: yup.number().nullable().defined(),
    createdById: yup
      .number()
      .min(0)
      .required(requiredField("Служител, зареждащ картата"))
      .defined(),
    isDeleted: yup.boolean().required().defined(),
    originalNumberOfVisits: yup.number().nullable().defined(),
  })
  .required();

export type IRefillCardFormModel = yup.InferType<typeof refillCardFormSchema>;

export const refillCardFormDefaultValues: IRefillCardFormModel = {
  editUserPlanId: null,
  studioId: 0,
  userId: 0,
  familyId: 0,
  planId: 0,
  paymentTypeId: 0,
  startDate: new Date(),
  endDate: new Date(),
  numberOfVisits: 0,
  price: 0,
  currencyId: CurrencyType.EUR,
  createdById: 0,
  isDeleted: false,
  originalNumberOfVisits: null,
};
